import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-8 md:pt-24 md:pb-12 overflow-hidden bg-main" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-70">
          {/* Text Content */}
          <div className="order-2 lg:order-1 space-y-8" data-id="element-71">
            <div className="inline-block text-accent text-xs uppercase tracking-widest font-semibold" data-id="element-72">
              MÉTODO FACELESS SPAIN (PDF)
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight text-title" data-id="element-73">
              Tu negocio invisible.
            </h1>

            <p className="text-lg md:text-xl text-body max-w-lg leading-relaxed" data-id="element-74">
              Crea una cuenta estética y anónima en Instagram sin mostrar tu
              cara, sin bailar y sin exponerte al juicio de tu entorno.
            </p>

            <ul className="space-y-3 text-body" data-id="element-75">
              <li className="flex items-start" data-id="element-76">
                <Check className="h-5 w-5 text-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-77" />
                <span data-id="element-78">Sin cámara frontal ni vida privada pública</span>
              </li>
              <li className="flex items-start" data-id="element-79">
                <Check className="h-5 w-5 text-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-80" />
                <span data-id="element-81">
                  Sistema claro para publicar con estética + intención
                </span>
              </li>
              <li className="flex items-start" data-id="element-82">
                <Check className="h-5 w-5 text-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-83" />
                <span data-id="element-84">Ideal si tienes trabajo, familia y poco tiempo</span>
              </li>
            </ul>

            <div className="pt-4" data-id="element-85">
              <Button size="lg" withArrow className="w-full sm:w-auto" href="#oferta" data-id="element-86">
                Ver qué incluye
              </Button>
              <p className="text-xs text-body mt-3 flex items-center justify-center sm:justify-start" data-id="element-87">
                Sin mostrar tu cara · En 2 minutos lo ves
              </p>
            </div>

            <div className="pt-6 border-t border-[#D9D0C1] flex items-center gap-4" data-id="element-88">
              <div className="flex -space-x-2" data-id="element-89">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-[#E7D8C8] border-2 border-[#F6F1E8] overflow-hidden" data-id="element-90">
                    <img src={`https://randomuser.me/api/portraits/women/${40 + i}.jpg`} alt="" className="w-full h-full object-cover grayscale opacity-80" data-id="element-91" />
                  </div>)}
              </div>
              <p className="text-sm text-body" data-id="element-92">
                +450 mujeres ya lo han probado.
              </p>
            </div>
          </div>

          {/* Image Content */}
          <div className="order-1 lg:order-2 relative" data-id="element-93">
            <div className="relative z-10 rounded-sm overflow-hidden shadow-2xl border-8 border-card" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/7BdzpwBVBFR2pt528RXThu/faceless.png" alt="Método Faceless Spain Ebook en tablet y móvil" className="w-full h-auto object-cover" data-id="element-95" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-alt rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-96"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-accent rounded-full mix-blend-multiply filter blur-3xl opacity-10" data-id="element-97"></div>
          </div>
        </div>
      </div>
    </section>;
}